import { DataScope } from 'src/app/core/models/data-scope';
import { Page } from './../../../../../core/models/page';
export class CustomerSignatureSampleStampRequest extends Page {
  facility: string | null;
  orgId: string | null;
  consigneeCompany: string[] | null;
  consigneeKey: string[] | null;
  chooseOnlyNone: boolean;
  userId: string | null;
  userDataScopes: DataScope[];
  brand: string[] | null;
  internalBrand: string[] | null;

  constructor() {
    super();
    this.facility = null;
    this.orgId = null;
    this.consigneeCompany = null;
    this.consigneeKey = null;
    this.userId = null;
    this.chooseOnlyNone = false;
    this.userDataScopes = [];
    this.brand = null;
    this.internalBrand = null;
  }
}
